(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ec-presell"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const decorateLinks = (root) => {
      const current = new URL(window.location.href);
      const experiment = root.dataset.ecExperiment;
      const arm = root.dataset.ecArm;

      root.querySelectorAll('[data-ec-presell-link]').forEach((link) => {
        const destination = new URL(link.href, window.location.origin);

        current.searchParams.forEach((value, key) => {
          if (key.startsWith('utm_') || ['fbclid', 'gclid', 'gbraid', 'wbraid', 'ttclid', 'msclkid'].includes(key)) {
            destination.searchParams.set(key, value);
          }
        });

        if (experiment) destination.searchParams.set('ec_experiment', experiment);
        if (arm) destination.searchParams.set('ec_arm', arm);
        link.href = destination.toString();
      });
    };

    const initialize = (scope = document) => {
      if (scope.matches?.('[data-ec-presell]')) decorateLinks(scope);
      scope.querySelectorAll('[data-ec-presell]').forEach(decorateLinks);
    };

    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
